import { render, staticRenderFns } from "./techActivity.vue?vue&type=template&id=22c9870e&"
import script from "./techActivity.vue?vue&type=script&lang=js&"
export * from "./techActivity.vue?vue&type=script&lang=js&"
import style0 from "./techActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports